import { Client } from '@/client'

class AppSettings {
    //backendUrl = "/console/back/"
    backendUrl = ""
}

const appSettings = new AppSettings();
const client: Client = new Client('');

function url(path: string): string {
    return appSettings.backendUrl + path;
}

function initUtil(baseUrl: string) {
    appSettings.backendUrl = baseUrl;
    client.baseUrl = baseUrl;
}

function saveFile(data: Blob, fileName: string) {
    const fileURL = window.URL.createObjectURL(data);
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
}

export {
    appSettings,
    client,
    url,
    initUtil,
    saveFile
}